import { readProfileBrief } from '@dinosband/bv-main-client'
import { DataCenter_ProxyType } from '../abstract'

export interface ProfileBrief {
  id: number
  name: string
  thumbnailId: number
  userId: number
  deleted: boolean
  blockChatting: boolean
}

export class Profiles extends DataCenter_ProxyType<number, ProfileBrief> {

  async init () {
    //
  }

  protected async query (id: number) {
    const profile = await readProfileBrief(await this.mainStore.apollo.getClient(), id)
    if (!profile) {
      return
    }
    return {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      id: profile.id!,
      name: profile.name ?? ' ',
      thumbnailId: profile.thumbnailId ?? -1,
      userId: profile.userId ?? 0,
      deleted: profile.deleted ?? false,
      blockChatting: profile.blockChatting ?? false,
    }
  }

}
